import ReactDatePicker from 'react-datepicker';
import { useWatch } from 'react-hook-form';
import { addDays } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import { FormControl } from 'react-bootstrap';
import { CalendarIcon } from '../dateTimePickerField/DateTimePickerField.styles';
import GenericFormField from '../genericFormField/GenericFormField';
import { RangePickerFieldWrapper } from './RangePickerField.styles';

interface Props {
  name: string;
  startDateFieldName: string;
  endDateFieldName: string;
  label?: string;
  help?: string;
  disabled?: boolean;
  maxDayRange?: number;
  'data-testid'?: string;
  onChange?: (dates: Date[]) => void;
  [key: string]: any;
}

const RangePickerField = ({
  name,
  startDateFieldName,
  endDateFieldName,
  help,
  label,
  'data-testid': dataTestId,
  onChange,
  disabled,
  maxDayRange,
  ...rest
}: Props) => {
  const startDate = useWatch({
    name: startDateFieldName,
  });
  const endDate = useWatch({
    name: endDateFieldName,
  });

  const fieldRenderer = ({ field: { ref } }: any) => (
    <RangePickerFieldWrapper data-testid={dataTestId}>
      <ReactDatePicker
        customInput={<FormControl data-testid={dataTestId} inputRef={ref} />}
        selected={startDate}
        // @ts-expect-error TS2769 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
        onChange={onChange}
        startDate={startDate}
        name="rangePicker"
        endDate={endDate}
        selectsRange
        disabled={disabled}
        popperClassName="date-time-picker-popper"
        maxDate={maxDayRange ? addDays(startDate, maxDayRange) : undefined}
      />
      <CalendarIcon />
    </RangePickerFieldWrapper>
  );

  return (
    <GenericFormField
      colSmInput={12}
      colSmLabel={0}
      name={name}
      fieldRenderer={fieldRenderer}
      help={help}
      label={label}
      disabled={disabled}
      {...rest}
    />
  );
};

RangePickerField.defaultProps = {
  'data-testid': undefined,
  label: '',
  help: '',
  disabled: false,
  maxDayRange: undefined,
  onChange: () => {},
};

export default RangePickerField;
